export const AuditLogMaintenanceConstant = {
    CATEGORY: "Support",
    TITLE: "Audit Log",
    UPDATED_DATE_RANGE: "Updated Date Range",
    UPDATED_DATE_FROM: "Updated Date From",
    UPDATED_DATE_TO: "Updated Date To",
    AUDIT_LOG_TYPE: "Audit Log Type",
    CNTR_NO: "Container No.",
    BILL_OF_LADING: "Bill of Lading",
    SHIPPING_BILL: "Shipping Bill",
    PROPOSAL_NO: "Proposal No.",
    FORWARDER_CODE: "Forwarder/Shipper/Consignee",
    OPS_LINE: "Ops Line",
    USER_ID: "User ID",
    AUDIT_LOG_INCIDENT: "Audit Log Incident",
    UPDATED_DATE: "Updated Date",
    CHARGE_TYPE: "Charge Type",
    SUB_CHARGE_TYPE: "Sub Charge Type",
    DTL_STATE_BF: "Charge Detail State - Before Value",
    DTL_STATE_AF: "Charge Detail State - After Value",
    BILL_TO_COMPANY_BF: "Bill-To Company - Before Value",
    BILL_TO_COMPANY_AF: "Bill-To Company - After Value",
    CHARGE_ON_COMPANY_BF: "Charge-On Company - Before Value",
    CHARGE_ON_COMPANY_AF: "Charge-On Company - After Value",
    COMPANY_CODE_BF: "Company Code - Before Value",
    COMPANY_CODE_AF: "Company Code - After Value",
    PRIORITY_BF: "Master FSP - Priority - Before Value",
    PRIORITY_AF: "Master FSP - Priority - After Value",
    STATUS_BF: "Master FSP - Status - Before Value",
    STATUS_AF: "Master FSP - Status - After Value",
    SHIPPING_LINE_BF: "Master FSP - Shipping Line - Before Value",
    SHIPPING_LINE_AF: "Master FSP - Shipping Line - After Value",
    EFFECTIVE_DATE_FROM_BF: "Master FSP - Effective Date From - Before Value",
    EFFECTIVE_DATE_FROM_AF: "Master FSP - Effective Date From - After Value",
    EFFECTIVE_DATE_TO_BF: "Master FSP - Effective Date To - Before Value",
    EFFECTIVE_DATE_TO_AF: "Master FSP - Effective Date To - After Value",
    CONSORTIUM_CODE: "Master FSP - Consortium Code",
    SERVICE_CODE_BF: "Master FSP - Service Code - Before Value",
    SERVICE_CODE_AF: "Master FSP - Service Code - After Value",
    FORWARDER_CODE_BF: "Master FSP - Consignee/Shipper/Forwarder - Before Value",
    FORWARDER_CODE_AF: "Master FSP - Consignee/Shipper/Forwarder - After Value",
    AGENT_CODE_BF: "Master FSP - Agent Code - Before Value",
    AGENT_CODE_AF: "Master FSP - Agent Code - After Value",
    CARGO_CODE_BF: "Master FSP - Cargo Code - Before Value",
    CARGO_CODE_AF: "Master FSP - Cargo Code - After Value",
    FSP_COUNTING_FROM_BF: "Master FSP - FSP Count From - Before Value",
    FSP_COUNTING_FROM_AF: "Master FSP - FSP Count From - After Value",
    FSP_COUNTING_TO_BF: "Master FSP - FSP Count To - Before Value",
    FSP_COUNTING_TO_AF: "Master FSP - FSP Count To - After Value",
    GRACE_HOUR_TO_BF: "Master FSP - Grace Hour Count To - Before Value",
    GRACE_HOUR_TO_AF: "Master FSP - Grace Hour Count To - After Value",
    GRACE_HOUR_FROM_BF: "Master FSP - Grace Hour Count From - Before Value",
    GRACE_HOUR_FROM_AF: "Master FSP - Grace Hour Count From - After Value",
    GRACE_MINUTE_TO_BF: "Master FSP - Grace Minute Count To - Before Value",
    GRACE_MINUTE_TO_AF: "Master FSP - Grace Minute Count To - After Value",
    GRACE_MINUTE_FROM_BF: "Master FSP - Grace Minute Count From - Before Value",
    GRACE_MINUTE_FROM_AF: "Master FSP - Grace Minute Count From - After Value",
    SHIPMENT_TYPE_BF: "Master FSP - Shipment Type - Before Value",
    SHIPMENT_TYPE_AF: "Master FSP - Shipment Type - After Value",
    FSP_COUNTING_DIRECTION_BF: "Master FSP - Fsp Counting direction - Before Value",
    FSP_COUNTING_DIRECTION_AF: "Master FSP - Fsp Counting direction - After Value",
    FSP_DAYS_BF: "Master FSP - FSP Days - Before Value",
    FSP_DAYS_AF: "Master FSP - FSP Days - After Value",
    FSP_UOM_BF: "Master FSP - UOM - Before Value",
    FSP_UOM_AF: "Master FSP - UOM - After Value",
    CHARGE_TYPE_BF: "Master FSP - Charge Type - Before Value",
    CHARGE_TYPE_AF: "Master FSP - Charge Type - After Value",
    SUB_CHARGE_TYPE_BF: "Master FSP - Sub Charge Type - Before Value",
    SUB_CHARGE_TYPE_AF: "Master FSP - Sub Charge Type - After Value",
    CNTR_MOVEMENT_BF: "Master FSP - Container Movement - Before Value",
    CNTR_MOVEMENT_AF: "Master FSP - Container Movement - After Value",
    CNTR_STATUS_BF: "Master FSP - Container Status - Before Value",
    CNTR_STATUS_AF: "Master FSP - Container Status - After Value",
    CUSTOMER_TYPE_BF: "Master FSP - Bill-To Company CustomerType - Before Value",
    CUSTOMER_TYPE_AF: "Master FSP - Bill-To Company CustomerType - After Value",
    FORWARDER_REF_BF: "Master FSP - Forwarder Ref - Before Value",
    FORWARDER_REF_AF: "Master FSP - Forwarder Ref - After Value",
    CALCULATION_BASIS: "Master FSP - Calculation Basis",
    VESSEL_CODE: "Master FSP - Vessel Code",
    VOYAGE_CODE: "Master FSP - Voyage Code",
    APPLY_CALENDAR_ADJ_BF: "Master FSP - Apply Calendar Adj - Before Value",
    APPLY_CALENDAR_ADJ_AF: "Master FSP - Apply Calendar Adj - After Value",
    SPLIT_FIRST_DAYS_BF: "Master FSP - Split First Days - Before Value",
    SPLIT_FIRST_DAYS_AF: "Master FSP - Split First Days - After Value",
    SPLIT_FIRST_DAYS_TO_BF: "Master FSP - Split First Days To - Before Value",
    SPLIT_FIRST_DAYS_TO_AF: "Master FSP - Split First Days To - After Value",
    SPLIT_REMAIN_DAYS_TO_BF: "Master FSP - Split Remain Days To - Before Value",
    SPLIT_REMAIN_DAYS_TO_AF: "Master FSP - Split Remain Days To - After Value",
    REJECT_REASON_BF: "Master FSP - Reject Reason - Before Value",
    REJECT_REASON_AF: "Master FSP - Reject Reason - After Value",
    REMARKS_BF: "Master FSP - Remarks - Before Value",
    REMARKS_AF: "Master FSP - Remarks - After Value",
    GRACE_EXTEND_BF: "Master FSP - Grace Hours Extended - Before Value",
    GRACE_EXTEND_AF: "Master FSP - Grace Hours Extended - After Value",
    ACTIVE_IND_BF: "Master FSP - Active Indicator - Before Value",
    ACTIVE_IND_AF: "Master FSP - Active Indicator - After Value",
    DRAFT_DOC_NO_BF: "Collection - Draft Invoice No. - Before Value",
    DRAFT_DOC_NO_AF: "Collection - Draft Invoice No. - After Value",
    DOC_NO_BF: "Collection - Final Invoice No. - Before Value",
    DOC_NO_AF: "Collection - Final Invoice No. - After Value",
    RECEIPT_NO_BF: "Collection - Receipt No. - Before Value",
    RECEIPT_NO_AF: "Collection - Receipt No. - After Value",
}
